import React from 'react'
import { Link, NavLink } from 'react-router-dom'
import secureLocalStorage from 'react-secure-storage';
import Opps404 from "../assets/images/404.svg"

const PageNotFound = () => {
    const accessToken = secureLocalStorage.getItem('accessToken');

    return (
        <div style={{ height: '100vh' }} className='d-flex justify-content-center align-items-center '>
            <img width={600} src={Opps404} />
            <div>
                {/* <NavLink className='pageNotFoundBtn' style={{ textDecoration: 'none' }} to="/">Go to {accessToken ? "home" : "login"}</NavLink> */}
            </div>
        </div>
    )
}

export default PageNotFound
